import {
  Building2,
  Factory,
  FlaskConical,
  Home,
  Hotel,
  Layers,
  type LucideIcon,
} from 'lucide-react';

const PROJECT_TYPE_ICONS: Record<string, LucideIcon> = {
  Residential: Home,
  'Mixed use': Layers,
  Industrial: Factory,
  'Office / lab': FlaskConical,
  Hospitality: Hotel,
};

export function getProjectTypeIcon(type: string): LucideIcon {
  return PROJECT_TYPE_ICONS[type] ?? Building2;
}
